<template>
  <div class="import-map-save-ui">
    <VForm @on-submit="saveMappingConfig">
      <div class="import-map-save-ui__row">
        <div class="import-map-save-ui__input">
          <VInput
            v-model="name"
            :config="{
              label: 'Save your mapping configuration',
              type: 'string',
              readonly: isDisabled,
            }"
          />
        </div>
        <VBtn type="submit" :disabled="isDisabled">Save</VBtn>
      </div>
    </VForm>
  </div>
</template>

<script lang="ts" setup>
  // Types
  import type { EMappingVariant, ESourceType, TImportColumnIndexes } from '~/shared/import/types';

  // Models
  import { ImportMapModel } from '~/modules/manager/models/import-map.model'; // TODO: replace with abstraction

  // Composables
  import { useNotifyResource } from '~/misc/resource/composables/use-notify-resource';

  // Components
  import VBtn from '~/misc/v-btn';
  import VInput from '~/misc/v-input';
  import VForm from 'homesearch-vue-common/dist/components/v-form';

  const props = defineProps({
    companyId: {
      type: Number,
      required: true,
    },
    headerIndexes: {
      type: Object as PropType<TImportColumnIndexes>,
      required: true,
    },
    variant: {
      type: String as PropType<EMappingVariant>,
      required: true,
    },
    sourceType: {
      type: String as PropType<ESourceType>,
      required: true,
    },
    selectedSourceId: {
      type: Number as PropType<number | null>,
      default: null,
    },
    selectedSourceName: {
      type: String as PropType<string | null>,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      required: false,
    },
  });

  const importMapModel = new ImportMapModel();

  const { notifySuccess } = useNotifyResource();

  const name: Ref<string> = ref<string>('');
  const isLoading: Ref<boolean> = ref<boolean>(false);
  const hasError: Ref<boolean> = ref<boolean>(false);

  const setIsLoading = (state: boolean) => {
    isLoading.value = state;
  };

  const setHasError = (state: boolean) => {
    hasError.value = state;
  };

  const saveMappingConfig = async () => {
    try {
      setIsLoading(true);

      await importMapModel.create(props.companyId, {
        name: name.value,
        config: props.headerIndexes,
        column_layout: props.variant,
        source_type: props.sourceType,
        source_id: props.selectedSourceId ?? undefined,
        source_name: props.selectedSourceName ?? undefined,
      });

      notifySuccess();
    } catch (error) {
      setHasError(true);
    } finally {
      setIsLoading(false);
    }
  };
</script>
